export const hasValue = (value: any) => value !== null && value !== undefined && value !== ''

export const getErrorMessage = (err: unknown, message: string) => {
  if (err instanceof Error) message = err.message
  return message
}

// An error message is unsafe to show a user if it looks like a raw serialized
// response rather than a human sentence — e.g. graphql-request embeds the whole
// stringified GraphQL response (query, variables, extensions) into error.message.
const looksLikeRawResponse = (message: string) =>
  /\{"response"|"errors":|"query":|"extensions":|GEOCODING_FAILED/.test(message) ||
  message.length > 300

// Like getErrorMessage, but never surfaces a raw serialized-response blob to the
// user; falls back to the provided friendly message when the error looks unsafe.
export const getSafeErrorMessage = (err: unknown, fallback: string) => {
  const message = err instanceof Error ? err.message : undefined
  if (!message || looksLikeRawResponse(message)) {
    return fallback
  }
  return message
}
